import { type ReactNode } from 'react';

import useIsTruncated from 'hooks/useIsTruncated';
import { cn } from 'support/helpers/cn/cn';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/Display/Tooltip/Tooltip';

type ListTableLongCellProps = {
  children: ReactNode;
  tooltipContent?: ReactNode;
  /** Extra classes for the truncating element. Cannot change the cap — use `maxWidthClassName`. */
  className?: string;
  /** Replaces the default `max-w-xs` cap. */
  maxWidthClassName?: string;
};

export const ListTableLongCell = ({
  children,
  tooltipContent,
  className,
  maxWidthClassName = 'max-w-xs',
}: ListTableLongCellProps) => {
  const [ref, isTruncated] = useIsTruncated();

  return (
    <Tooltip enabled={isTruncated}>
      <TooltipTrigger>
        {/* The cap goes last so cn's merge keeps it over any max-w-* passed in className. */}
        <span ref={ref} className={cn('block truncate', className, maxWidthClassName)}>
          {children}
        </span>
      </TooltipTrigger>
      <TooltipContent>{tooltipContent ?? children}</TooltipContent>
    </Tooltip>
  );
};
